import { render, staticRenderFns } from "./InviteSupplier.vue?vue&type=template&id=28a19d6c&scoped=true&"
import script from "./InviteSupplier.vue?vue&type=script&lang=js&"
export * from "./InviteSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a19d6c",
  null
  
)

export default component.exports